import React from "react";
import Modal from "react-modal";
import "./StockLimitModal.css";

const StockLimitModal = ({ isOpen, onClose }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnOverlayClick={true}
      contentLabel="Stock limit"
      className="stock_limit_modal"
      overlayClassName="stock_limit_overlay"
    >
      <div className="modal_exit" onClick={onClose} aria-label="Close" />
      <h3 className="stock_limit_modal_title">Can't add more!</h3>
      <p className="stock_limit_modal_message">
        The quantity in your basket may already be at the maximum available stock.
      </p>
      <button type="button" className="proceed_to_payment_btn stock_limit_modal_btn" onClick={onClose}>
        OK
      </button>
    </Modal>
  );
};

export default StockLimitModal;
